import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import PileRecordTab from "./PileRecordTab";
import ManpowerLogTab from "./ManpowerLogTab";
import LabourCategoryTab from "./LabourCategoryTab";
import DieselRegisterTab from "./DieselRegisterTab";
import BulletsRegisterTab from "./BulletsRegisterTab";
import DocumentRegisterTab from "./DocumentRegisterTab";
import { NoAccess } from "../equipment/shared/NoAccess";

const SE_AND_HO = ["Director", "Manager", "Back Office", "Site Engineer"];
const HO_ONLY = ["Director", "Manager", "Back Office"];

const TABS = [
  { key: "pile-record", label: "Pile Record / DPR", Component: PileRecordTab, roles: SE_AND_HO },
  { key: "manpower-log", label: "Manpower Log", Component: ManpowerLogTab, roles: SE_AND_HO },
  { key: "labour-category", label: "Labour Category Master", Component: LabourCategoryTab, roles: HO_ONLY },
  { key: "diesel-register", label: "Diesel Register", Component: DieselRegisterTab, roles: SE_AND_HO },
  { key: "bullets-register", label: "Bullets Register", Component: BulletsRegisterTab, roles: SE_AND_HO },
  { key: "document-register", label: "Document Register", Component: DocumentRegisterTab, roles: SE_AND_HO },
];

export default function OperationsPage() {
  const { user } = useAuth();
  const visible = TABS.filter((t) => t.roles.includes(user?.role));
  const [active, setActive] = useState(visible[0]?.key);

  if (visible.length === 0) return <NoAccess />;

  return (
    <div className="space-y-6" data-testid="operations-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Operations / Site Ops
        </h1>
        <p className="text-sm text-slate-500">Pile records, manpower logs, diesel &amp; bullets registers, document archive.</p>
      </div>
      <Tabs value={active} onValueChange={setActive}>
        <TabsList className="flex-wrap h-auto">
          {visible.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`operations-tab-${t.key}`}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {visible.map((t) => (
          <TabsContent key={t.key} value={t.key} className="pt-4">
            <t.Component />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
